/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

// Used for run time syntax checking
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function gql(_input) {
  throw new Error('Calls to this function should be erased at compile time. is graphqlParse enabled in the webpack config?');
}

// eslint-disable-next-line hubspot-dev/no-declarations, @typescript-eslint/no-namespace
export let CvAssignmentsCoreAssignees;

// eslint-disable-next-line hubspot-dev/no-declarations, @typescript-eslint/no-namespace
(function (_CvAssignmentsCoreAssignees) {})(CvAssignmentsCoreAssignees || (CvAssignmentsCoreAssignees = {}));
export let MessagesBaseV2;

// eslint-disable-next-line hubspot-dev/no-declarations, @typescript-eslint/no-namespace
(function (_MessagesBaseV) {})(MessagesBaseV2 || (MessagesBaseV2 = {}));
export let CvActorsCore;

// eslint-disable-next-line hubspot-dev/no-declarations, @typescript-eslint/no-namespace
(function (_CvActorsCore) {})(CvActorsCore || (CvActorsCore = {}));
export let CrmPropertiesDefaultsOptionsUser;

// eslint-disable-next-line hubspot-dev/no-declarations, @typescript-eslint/no-namespace
(function (_CrmPropertiesDefaultsOptionsUser) {})(CrmPropertiesDefaultsOptionsUser || (CrmPropertiesDefaultsOptionsUser = {}));
export let ChirpCore;

// eslint-disable-next-line hubspot-dev/no-declarations, @typescript-eslint/no-namespace
(function (_ChirpCore) {})(ChirpCore || (ChirpCore = {}));
export let CvAssignmentsCoreAssigneesAbstractAssigneeError;
(function (_CvAssignmentsCoreAssigneesAbstractAssigneeError) {})(CvAssignmentsCoreAssigneesAbstractAssigneeError || (CvAssignmentsCoreAssigneesAbstractAssigneeError = {}));
const cv_assignments_rpc_AssigneeService_getAssignees_query = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_rpc_AssigneeService_getAssignees\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"request\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_core_assignees_AssigneeRequestInput\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_rpc_AssigneeService_getAssignees\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"request\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"request\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_core_assignees_AssigneePagedResponse\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"_all\"}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_core_assignees_AssigneeError\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"_all\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "cv_assignments_rpc_AssigneeService_getAssignees"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "request"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "cv_assignments_core_assignees_AssigneeRequestInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "cv_assignments_rpc_AssigneeService_getAssignees"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "request"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "request"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "cv_assignments_core_assignees_AssigneePagedResponse"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "_all"
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "cv_assignments_core_assignees_AssigneeError"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "_all"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
const cv_assignments_rpc_AssigneeService_getAssignee_query = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_rpc_AssigneeService_getAssignee\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"request\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_core_assignees_SingleAssigneeRequestInput\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_rpc_AssigneeService_getAssignee\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"request\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"request\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_core_assignees_Assignee\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"_all\"}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"cv_assignments_core_assignees_AssigneeError\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"_all\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "cv_assignments_rpc_AssigneeService_getAssignee"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "request"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "cv_assignments_core_assignees_SingleAssigneeRequestInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "cv_assignments_rpc_AssigneeService_getAssignee"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "request"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "request"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "cv_assignments_core_assignees_Assignee"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "_all"
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "cv_assignments_core_assignees_AssigneeError"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "_all"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const getAssigneesRpc = {
  gateway: '/chirp-graphql-gateway-app/v1/graphql',
  name: 'cv_assignments_rpc_AssigneeService_getAssignees',
  query: cv_assignments_rpc_AssigneeService_getAssignees_query
};
export const getAssigneeRpc = {
  gateway: '/chirp-graphql-gateway-app/v1/graphql',
  name: 'cv_assignments_rpc_AssigneeService_getAssignee',
  query: cv_assignments_rpc_AssigneeService_getAssignee_query
};